import { Notification } from 'element-ui';
import store from '../store';
import i18n from '../i18n';
import router from '../router';
import { withApiBase } from '../api/base';
import { sendNativeNotification } from './attention';

/* 鈹€鈹€ Notification helper 鈹€鈹€ */
const ICON_MAP = {
  ticket:       'el-icon-document',
  dispute:      'el-icon-warning-outline',
  task:         'el-icon-bell',
  announcement: 'el-icon-message',
  admin:        'el-icon-s-tools'
};

function escapeHtml(str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

const activeNotifications = new Map();
const REMINDER_TYPES = new Set([
  'CASE_URGED',
  'DISPUTE_URGED',
  'FIRST_RESPONSE_TIMEOUT',
  'CLOSE_TIMEOUT',
  'DISPUTE_TIMEOUT'
]);

function closeNotificationKey(key) {
  if (!key) return;
  const old = activeNotifications.get(key);
  if (!old) return;
  try {
    old.close();
  } catch (e) {}
  activeNotifications.delete(key);
}

function closeNotificationKeys(keys) {
  (keys || []).forEach(closeNotificationKey);
}

function closeCaseNotifications(caseNo) {
  if (!caseNo) return;
  closeNotificationKeys([
    `case:${caseNo}`,
    `case_pool:${caseNo}`,
    `case_taken:${caseNo}`,
    `case_returned:${caseNo}`,
    `case_closed:${caseNo}`,
    `case_urge:${caseNo}`,
    `case_timeout:${caseNo}`
  ]);
}

function closeDisputeNotifications(disputeId) {
  if (!disputeId) return;
  closeNotificationKeys([
    `dispute:${disputeId}`,
    `dispute_pool:${disputeId}`,
    `dispute_taken:${disputeId}`,
    `dispute_closed:${disputeId}`,
    `dispute_urge:${disputeId}`,
    `dispute_timeout:${disputeId}`
  ]);
}

function sseNotify({ category, title, body, type, route, duration, key }) {
  const icon = ICON_MAP[category] || 'el-icon-info';
  const safeBody = escapeHtml(body);
  closeNotificationKey(key);
  const routePath = typeof route === 'string' ? route : (route && route.path ? route.path : '');
  const n = Notification({
    title: escapeHtml(title),
    dangerouslyUseHTMLString: true,
    message: `<div class="sse-notif__row"><i class="${icon} sse-notif__icon"></i><span class="sse-notif__body">${safeBody}</span></div>`,
    type: type || 'info',
    duration: duration == null ? 0 : duration,
    customClass: 'sse-notif',
    onClick() {
      n.close();
      closeNotificationKey(key);
      if (route && (!routePath || router.currentRoute.path !== routePath || JSON.stringify(router.currentRoute.query || {}) !== JSON.stringify((route && route.query) || {}))) {
        router.push(route).catch(() => {});
      }
    },
    onClose() {
      if (key && activeNotifications.get(key) === n) {
        activeNotifications.delete(key);
      }
    }
  });
  if (key) activeNotifications.set(key, n);
  sendNativeNotification(title, body, route, category, true);
}

function sameId(a, b) {
  if (a == null || b == null) return false;
  return String(a) === String(b);
}

function caseEventBelongsToRole(role, data, currentUserId) {
  if (!role || !data) return false;
  const type = data.type ? String(data.type) : '';
  if (role === 'ADMIN') return true;
  if (role === 'USER') return true;
  if (role === 'SECONDARY_HANDLER') {
    return sameId(data.assignedSecondaryHandlerId, currentUserId) || sameId(data.createdBy, currentUserId);
  }
  if (role === 'HANDLER') {
    if (sameId(data.assignedHandlerId, currentUserId)) return true;
    return type === 'CASE_CREATED' || type === 'CASE_RESUBMITTED' || type === 'CASE_ESCALATED'
      || type === 'CASE_TAKEN' || type === 'CASE_RELEASED' || type === 'CASE_CANCELED' || type === 'DISPUTE_CLOSED'
      || REMINDER_TYPES.has(type);
  }
  return false;
}

function disputeEventBelongsToRole(role, data, currentUserId) {
  if (!role || !data) return false;
  const type = data.type ? String(data.type) : '';
  if (role === 'ADMIN') return true;
  if (role === 'USER') return true;
  if (role === 'SECONDARY_HANDLER') {
    return sameId(data.assignedSecondaryHandlerId, currentUserId) || sameId(data.createdBy, currentUserId);
  }
  if (role === 'HANDLER') {
    if (sameId(data.assignedHandlerId, currentUserId)) return true;
    return type === 'DISPUTE_CREATED' || type === 'DISPUTE_RELEASED' || type === 'DISPUTE_TAKEN' || type === 'DISPUTE_CLOSED'
      || REMINDER_TYPES.has(type);
  }
  return false;
}

let es = null;
let retryTimer = null;
let retryCount = 0;
const RETRY_BASE_MS = 1500;
const RETRY_MAX_MS = 60000;
let sessionExpiredPending = false;  // Track if session expired while tab was hidden

function close() {
  if (es) {
    try {
      es.close();
    } catch (e) {}
  }
  es = null;
  if (retryTimer) clearTimeout(retryTimer);
  retryTimer = null;
}

function scheduleReconnect() {
  if (retryTimer) return;
  // Exponential backoff: 1.5s, 3s, 6s, 12s, ... capped at 60s
  const delay = Math.min(RETRY_MAX_MS, RETRY_BASE_MS * Math.pow(2, retryCount));
  retryCount++;
  retryTimer = setTimeout(() => {
    retryTimer = null;
    start();
  }, delay);
}

export function start() {
  // Auth is cookie-based; start stream only after /api/me has been loaded.
  if (!store.state.user) return;
  if (es) return;

  // EventSource cannot set Authorization headers; cookies are automatically attached (same-site).
  es = new EventSource(withApiBase('/api/stream'), { withCredentials: true });

  es.addEventListener('unauthorized', () => {
    // Token invalid/expired/invalidated: stop reconnect loop and force logout.
    close();

    const title = i18n.t('auth.sessionExpired') || '\u767b\u5f55\u5df2\u8fc7\u671f';
    const message = i18n.t('auth.pleaseLoginAgain') || '\u767b\u5f55\u5df2\u8fc7\u671f\uff0c\u8bf7\u91cd\u65b0\u767b\u5f55';

    const showSessionExpiredNotification = () => {
      try {
        // Show persistent notification that requires user action
        const notif = Notification({
          title,
          message,
          type: 'warning',
          duration: 0,  // Don't auto-close - requires user action
          showClose: true,
          onClick: () => {
            notif.close();
            sessionExpiredPending = false;
            store.dispatch('logout');
            if (router.currentRoute.path !== '/login') router.replace('/login');
          }
        });
      } catch (e) {
        // Fallback: if notification fails, still logout and redirect
        sessionExpiredPending = false;
        store.dispatch('logout');
        if (router.currentRoute.path !== '/login') router.replace('/login');
      }
    };

    // If tab is hidden, delay web notification but send native notification immediately
    if (document.hidden) {
      sessionExpiredPending = true;

      // Send native system notification immediately (user will see it in notification center)
      // Use persistent=true to keep notification visible until clicked
      // Pass logout callback to ensure user is logged out before navigation
      sendNativeNotification(
        title,
        message,
        '/login',
        'auth',
        true,
        async () => {
          sessionExpiredPending = false;
          await store.dispatch('logout');
        }
      );

      // Wait for user to return to show web notification
      const visibilityHandler = () => {
        if (!document.hidden && sessionExpiredPending) {
          sessionExpiredPending = false;
          document.removeEventListener('visibilitychange', visibilityHandler);
          showSessionExpiredNotification();
        }
      };
      document.addEventListener('visibilitychange', visibilityHandler);
    } else {
      // Tab is visible, show web notification immediately
      // Native notification won't be sent because tabVisible = true
      showSessionExpiredNotification();
    }
  });

  es.addEventListener('hello', async () => {
    // Connection established: reset backoff counter.
    retryCount = 0;
    // Reconnect/back-online: do one-time sync so UI doesn't require manual refresh.
    try {
      await store.dispatch('refreshMe');
      await store.dispatch('refreshTaskRedDot');
      await store.dispatch('refreshTicketRedDot');
      await store.dispatch('refreshTicketNeedMore');
      await store.dispatch('refreshAdminBadges');
      await store.dispatch('refreshHandlerBadges');
      await store.dispatch('refreshSecondaryBadges');
    } catch (e) {}
    store.commit('bumpVersion', 'tasks');
    store.commit('bumpVersion', 'announcements');
    store.commit('bumpVersion', 'userCases');
    store.commit('bumpVersion', 'handlerCases');
    store.commit('bumpVersion', 'secondaryCases');
    store.commit('bumpVersion', 'disputes');
  });

  es.addEventListener('caseEvent', (evt) => {
    try {
      const data = JSON.parse(evt.data);
      const role = store.state.user && store.state.user.role ? store.state.user.role : null;
      if (!role) return;
      const type = data && data.type ? String(data.type) : '';
      const isDispute = !!type && type.startsWith('DISPUTE_');
      const isReminder = REMINDER_TYPES.has(type);
      const isTaskAssigned = type === 'TASK_ASSIGNED';
      const actorUserId = data && data.actorUserId != null ? String(data.actorUserId) : '';
      const currentUserId = store.state.user && store.state.user.id != null ? String(store.state.user.id) : '';
      if (isDispute && !disputeEventBelongsToRole(role, data, currentUserId)) {
        return;
      }
      if (!isDispute && !isTaskAssigned && !caseEventBelongsToRole(role, data, currentUserId)) {
        return;
      }
      const caseNo = data && data.caseNo ? String(data.caseNo) : '';
      const disputeId = data && data.disputeId != null ? String(data.disputeId) : '';
      if (type === 'CASE_TAKEN' || type === 'CASE_RELEASED' || type === 'CASE_RETURNED' || type === 'CASE_ESCALATED_RETURNED' || type === 'CASE_ESCALATED' || type === 'CASE_CANCELED' || type === 'CASE_CLOSED') {
        closeCaseNotifications(caseNo);
      }
      if (type === 'DISPUTE_TAKEN' || type === 'DISPUTE_RELEASED' || type === 'DISPUTE_SECONDARY_ESCALATED' || type === 'DISPUTE_CLOSED') {
        closeDisputeNotifications(disputeId);
      }

      // Always refresh lists/counts; toast rules are role-specific.
      if (isTaskAssigned) {
        store.commit('bumpVersion', 'tasks');
      } else if (isDispute) {
        store.commit('bumpVersion', 'disputes');
        if (role === 'HANDLER') store.commit('bumpVersion', 'handlerCases');
        else if (role === 'SECONDARY_HANDLER') store.commit('bumpVersion', 'secondaryCases');
        else store.commit('bumpVersion', 'userCases');
      } else {
        if (role === 'HANDLER') store.commit('bumpVersion', 'handlerCases');
        else if (role === 'SECONDARY_HANDLER') store.commit('bumpVersion', 'secondaryCases');
        else store.commit('bumpVersion', 'userCases');
      }

      if (role === 'USER') {
        store.dispatch('refreshTicketRedDot');
        store.dispatch('refreshTicketNeedMore');
      }
      if (role === 'HANDLER') store.dispatch('refreshHandlerBadges');
      if (role === 'SECONDARY_HANDLER') store.dispatch('refreshSecondaryBadges');

      // Toast policy:
      // - USER: only "taken" + "returned (need more)"
      // - HANDLER: only "new in pool" (case/dispute created/resubmitted)
      // - ADMIN: keep existing admin_badges system; suppress caseEvent toast
      let shouldToast = false;
      let toastType = 'info';
      let title = i18n.t('ticket.ticketNo');

      if (role === 'USER') {
        shouldToast =
          type === 'CASE_TAKEN' ||
          type === 'CASE_RETURNED' ||
          type === 'CASE_CLOSED' ||
          type === 'DISPUTE_TAKEN' ||
          type === 'DISPUTE_CLOSED';
        if (type === 'CASE_RETURNED') toastType = 'warning';
        else if (type === 'DISPUTE_CLOSED') {
          const r = data && data.result ? String(data.result) : '';
          toastType = r === 'REJECTED' ? 'error' : 'success';
        } else if (type === 'DISPUTE_TAKEN') toastType = 'info';
        else toastType = 'success';
        title = i18n.t('menu.tickets');
      } else if (role === 'HANDLER') {
        shouldToast = type === 'CASE_CREATED' || type === 'CASE_RESUBMITTED' || type === 'CASE_ESCALATED' || type === 'DISPUTE_CREATED' || isReminder;
        toastType = 'warning';
        title = isDispute ? i18n.t('menu.handlerDisputes') : (data && data.assignedHandlerId ? i18n.t('menu.handlerInProgress') : i18n.t('menu.handlerPool'));
      } else if (role === 'SECONDARY_HANDLER') {
        shouldToast = type === 'CASE_ASSIGNED' || type === 'CASE_RESUBMITTED' || type === 'CASE_RETURNED' || type === 'CASE_ESCALATED_RETURNED' || type === 'CASE_ESCALATED' || type === 'CASE_TAKEN' || type === 'CASE_RELEASED' || type === 'CASE_CANCELED' || type === 'CASE_CLOSED' || type === 'TASK_ASSIGNED' || type === 'DISPUTE_SECONDARY_CREATED' || type === 'DISPUTE_SECONDARY_ESCALATED' || type === 'DISPUTE_TAKEN' || type === 'DISPUTE_CLOSED' || isReminder;
        toastType = type === 'CASE_RETURNED' || type === 'CASE_ESCALATED_RETURNED' || type === 'DISPUTE_SECONDARY_CREATED' ? 'warning' : 'info';
        title = type === 'TASK_ASSIGNED' ? i18n.t('menu.tasks') : (isDispute ? i18n.t('secondary.disputeCases') : i18n.t('menu.handlerInProgress'));
      } else {
        shouldToast = false;
      }
      if (shouldToast && actorUserId && currentUserId && actorUserId === currentUserId) {
        shouldToast = false;
      }

      if (shouldToast) {
        const typeLabel = type ? (i18n.te(`event.${type}`) ? i18n.t(`event.${type}`) : type) : '';
        const ref = isDispute
          ? (disputeId ? `${i18n.t('ticket.disputeLabel')} #${disputeId}${caseNo ? ` / ${i18n.t('ticket.ticketNo')} ${caseNo}` : ''}` : '')
          : (caseNo ? `${i18n.t('ticket.ticketNo')} ${caseNo}` : '');
        let extra = '';
        if (role === 'USER' && type === 'DISPUTE_CLOSED') {
          const r = data && data.result ? String(data.result) : '';
          if (r && i18n.te(`dispute.result.${r}`)) extra = ` (${i18n.t(`dispute.result.${r}`)})`;
        }
        const category = isDispute ? 'dispute' : 'ticket';
        let route = { path: '/dashboard' };
        if (role === 'USER') route = { path: '/tickets', query: caseNo ? { caseNo } : {} };
        else if (role === 'HANDLER') {
          const path = isDispute
            ? (data && data.assignedHandlerId ? '/handler/in-progress' : '/handler/disputes')
            : (type === 'CASE_TAKEN' || type === 'CASE_RETURNED' || type === 'CASE_CLOSED' || type === 'CLOSE_TIMEOUT' || data.assignedHandlerId ? '/handler/in-progress' : '/handler/pool');
          route = { path, query: caseNo ? { caseNo } : {} };
        }
        else if (role === 'SECONDARY_HANDLER') {
          let path = '/secondary/pending';
          if (type === 'TASK_ASSIGNED') path = '/secondary/tasks';
          else if (isDispute) path = '/secondary/pending';
          else if (type === 'CASE_CLOSED') path = '/secondary/closed';
          else if (type === 'CASE_RETURNED' && sameId(data.createdBy, currentUserId)) path = '/secondary/submit';
          route = { path, query: caseNo ? { caseNo } : {} };
        }

        let key = '';
        if (isDispute && disputeId) {
          key = `dispute:${disputeId}`;
          if (type === 'DISPUTE_CREATED' || type === 'DISPUTE_SECONDARY_CREATED') key = `dispute_pool:${disputeId}`;
          else if (type === 'DISPUTE_TAKEN') key = `dispute_taken:${disputeId}`;
          else if (type === 'DISPUTE_CLOSED') key = `dispute_closed:${disputeId}`;
          else if (type === 'DISPUTE_URGED') key = `dispute_urge:${disputeId}`;
          else if (type === 'DISPUTE_TIMEOUT') key = `dispute_timeout:${disputeId}`;
        } else if (caseNo) {
          key = `case:${caseNo}`;
          if (type === 'CASE_CREATED' || type === 'CASE_ASSIGNED' || type === 'CASE_RESUBMITTED' || type === 'CASE_ESCALATED') key = `case_pool:${caseNo}`;
          else if (type === 'CASE_TAKEN') key = `case_taken:${caseNo}`;
          else if (type === 'CASE_RETURNED' || type === 'CASE_ESCALATED_RETURNED') key = `case_returned:${caseNo}`;
          else if (type === 'CASE_CLOSED') key = `case_closed:${caseNo}`;
          else if (type === 'CASE_URGED') key = `case_urge:${caseNo}`;
          else if (type === 'FIRST_RESPONSE_TIMEOUT' || type === 'CLOSE_TIMEOUT') key = `case_timeout:${caseNo}`;
        }

        sseNotify({
          category,
          title,
          body: ref ? `${typeLabel}${extra} ${ref}` : `${typeLabel}${extra}`,
          type: toastType,
          route,
          key
        });
      }
    } catch (e) {
      // ignore
    }
  });

  es.addEventListener('notification', (evt) => {
    try {
      const data = JSON.parse(evt.data);
      const role = store.state.user && store.state.user.role ? store.state.user.role : null;
      const typeLabel = data && data.type ? (i18n.te(`event.${data.type}`) ? i18n.t(`event.${data.type}`) : data.type) : '';
      const msg = data.title || typeLabel;
      sseNotify({
        category: 'task',
        title: i18n.t('menu.tasks'),
        body: msg,
        type: 'warning',
        route: role === 'SECONDARY_HANDLER' ? '/secondary/tasks' : '/tasks',
        key: data && data.taskId ? `task:${data.taskId}` : 'task'
      });
      store.dispatch('refreshTaskRedDot');
      store.dispatch('refreshSecondaryBadges');
      store.commit('bumpVersion', 'tasks');
    } catch (e) {}
  });

  es.addEventListener('announcement', (evt) => {
    try {
      const data = JSON.parse(evt.data);
      const typeLabel = data && data.type ? (i18n.te(`event.${data.type}`) ? i18n.t(`event.${data.type}`) : data.type) : '';
      const msg = data.title || typeLabel;
      sseNotify({
        category: 'announcement',
        title: i18n.t('menu.announcements'),
        body: msg,
        type: 'info',
        route: '/dashboard',
        key: data && data.announcementId ? `announcement:${data.announcementId}` : 'announcement'
      });
      store.dispatch('refreshMe');
      store.commit('bumpVersion', 'announcements');
    } catch (e) {}
  });

  es.addEventListener('adminBadge', (evt) => {
    try {
      const data = JSON.parse(evt.data);
      const typeLabel = data && data.type ? (i18n.te(`event.${data.type}`) ? i18n.t(`event.${data.type}`) : data.type) : '';
      const msg = typeLabel || 'Update';
      sseNotify({
        category: 'admin',
        title: i18n.t('menu.dashboard'),
        body: msg,
        type: 'warning',
        route: '/dashboard',
        key: data && data.announcementId ? `admin_announcement:${data.announcementId}` : data && data.taskId ? `admin_task:${data.taskId}` : 'admin'
      });
      store.dispatch('refreshAdminBadges');
      // Admin lists should be able to refresh in-place.
      store.commit('bumpVersion', 'announcements');
      store.commit('bumpVersion', 'tasks');
    } catch (e) {}
  });

  es.onerror = () => {
    close();
    scheduleReconnect();
  };
}

export function stop() {
  close();
}
